/**
 * sentry配置
 * 1.1.3 需要在构造文件config/index.js中配置
 * production 需要在构建配置中配置config/index.js中配置
 */
export default {
  DNS: 'https://8b712704069047ad8efad5ef06004f9b@sentry.lixinio.com/133',
  config: {
    release: '1.1.3',
    logger: 'javascript',
    ignoreUrls: [/sentry\.lixinio\.com/, /hm\.baidu\.com/, /map\.qq\.com/],
    environment: 'production',
    ignoreErrors: [/^Can't find variable: WeixinJSBridge$/, /^WeixinJSBridge is not defined$/]
  }
}



// WEBPACK FOOTER //
// ./src/report/config.js